<template>

<v-dialog v-model="dialog" width="400px">
  <v-card>
    <p class=".title ma-2">Move Host payment to another booking</p>
    <v-form ref="mvHctrPayment" v-model="mvHctrPaymentValid1">

      <br />
      <p class="mx-2">     
       <v-select v-model="hctr_nr" required :items="hctr_nrKeuzes" item-value="hctr_nr" item-text="hctr_oms" label="Payment" dense :rules="hctr_nrRules"></v-select>
      </p>     
     
      <p class="mx-2">
          <v-text-field v-model="hctr_bedrag" required label="Amount to move" :prefix=hctr.valu_code type="number" :rules="hctr_bedragRules"></v-text-field>
      </p>
    
      <p class="mx-2">
          <v-text-field v-model="huov_code_moveto" required label="Booking ID where the payment moves to" :rules="huov_code_movetoRules"></v-text-field>
      </p>    
       
      <p v-if="hctr.huov_moveto_huis_code > ''" class="mx-2">
          
      Accommodation: {{hctr.huov_moveto_huis_code}} <br />
      Arrival: {{hctr.huov_moveto_vandat}} Departure: {{hctr.huov_moveto_tmdat}}<br />
      Host: {{hctr.huov_moveto_eign}} 
      </p>
      
      


    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="hctr.huov_moveto_huis_code > ''" class="primary mx-2" small @click="mvHctrPayment" :disabled="!mvHctrPaymentValid1">Move payment</v-btn>
      <v-btn class="primary mx-2" small @click="mvHctrPaymentCheck" :disabled="!mvHctrPaymentValid1">Check this data</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      mvHctrPaymentValid1: false,
      hoct_encrid: null,
      hctr_nr: '',
      hctr_bedrag: null,
      huov_code_moveto: null,
      hctr_nrKeuzes: [],
      hctr: {},
      hctr_nrRules: [
          v => (v && v.length >= 1) || "An code is required"
      ],
      huov_code_movetoRules: [
          v => (v && v.length >= 1) || "A booking ID is required"
      ],  
      hctr_bedragRules: [
          v => (v && v.length >= 1) || "An amount is required"
      ]    
    }
  },
  methods: {
    open(hoct_encrid) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.hoct_encrid = hoct_encrid;
      this.hctr_nrKeuzes.length = 0;
      this.hctr_dt = '';
      this.hctr_bedrag = '';
      this.hctr_nr = '';
      this.$axios
        .post("ares/json/ares/huov/hctr/getHctrToMvHctrPayment.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHctrToMvHctrPayment"
          },
          getHctrToMvHctrPayment: {
            hoct_encrid: hoct_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hctr = res.data.getHctrToMvHctrPayment;
            res.data.getHctrToMvHctrPayment.hctr_nrKeuzes.forEach(function(hctr) {
                deze.hctr_nrKeuzes.push(hctr); 
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    mvHctrPaymentCheck() { 
      this.$axios
        .post("ares/json/ares/huov/hctr/mvHctrPaymentCheck.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHctrPaymentCheck"
          },
          mvHctrPaymentCheck: {
            hoct_encrid: this.hoct_encrid,
            hctr_nr: this.hctr_nr,
            huov_code_moveto: this.huov_code_moveto,
            hctr_bedrag: parseFloat(this.hctr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {    
               this.hctr = res.data.mvHctrPaymentCheck;  
              if (res.data.mvHctrPaymentCheck.color == "error") {
                  this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.mvHctrPaymentCheck.text,
                        color: res.data.mvHctrPaymentCheck.color
                  }); 
              }  
          }
        })
    },
    mvHctrPayment() { 
      this.$axios
        .post("ares/json/ares/huov/hctr/mvHctrPayment.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "mvHctrPayment"
          },
          mvHctrPayment: {
            hoct_encrid: this.hoct_encrid,
            hctr_nr: this.hctr_nr,
            huov_code_moveto: this.huov_code_moveto,
            hctr_bedrag: parseFloat(this.hctr_bedrag)
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.mvHctrPayment.text,
              color: res.data.mvHctrPayment.color
            }); 
             if (res.data.mvHctrPayment.color == "success" ) {
              setTimeout(() => { this.$router.reload("/huov/onHuov/" + res.data.mvHctrPayment.huov_encrid); }, 1000); 
            }   
             
            this.dialog = false;
          }
        })
    },
  }
}
</script>

